import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    redirect: { name: 'index' },
    component: layoutHeaderAside,
    children: [
      // 首页
      {
        path: 'index_water',
        name: 'index_water',
        meta: {
          // title: '首页',
          title: '首页',
          auth: true
        },
        component: _import('system/index')
      },
      // 首页
      {
        path: 'index',
        name: 'index',
        meta: {
          title: '首页',
          auth: true
        },
        component: _import('system/index_water')
      },
      // 演示页面
      {
        path: '/sysuser',
        name: 'sysuser',
        meta: {
          title: '管理员',
          auth: true
        },
        component: _import('system/sysuser')
      },
      {
        path: '/sysresourse',
        name: 'sysresourse',
        meta: {
          title: '菜单管理',
          auth: true
        },
        component: _import('system/sysresourse')
      },
      {
        path: 'page3',
        name: 'page3',
        meta: {
          title: '页面 3',
          auth: true
        },
        component: _import('demo/page3')
      },
      // --------常用功能--------
      {
        path: 'userJiaofei',
        name: 'userJiaofei',
        meta: {
          title: '用户缴费',
          auth: true
        },
        component: _import('ChangYongGongNeng/userJiaofei')
      },
      {
        path: 'tongduankongzhi',
        name: 'tongduankongzhi',
        meta: {
          title: '通断控制',
          auth: true
        },
        component: _import('ChangYongGongNeng/tongduankongzhi')
      },
      {
        path: 'dianbiaoshishijilu',
        name: 'dianbiaoshishijilu',
        meta: {
          title: '电表查询',
          auth: true
        },
        component: _import('ChangYongGongNeng/dianbiaoshishijilu')
      },
      // 设备管理
      {
        path: 'mokuaiguanli',
        name: 'mokuaiguanli',
        meta: {
          title: '模块管理',
          auth: true
        },
        component: _import('SheBeiGuanLi/mokuaiguanli')
      },
      {
        path: 'dianbiaoguanli',
        name: 'dianbiaoguanli',
        meta: {
          title: '电表管理',
          auth: true
        },
        component: _import('SheBeiGuanLi/dianbiaoguanli')
      },
      {
        path: 'waterarchive',
        name: 'waterarchive',
        meta: {
          title: '水表档案',
          auth: true
        },
        component: _import('SheBeiGuanLi/waterarchive')
      },
      {
        path: 'waterstate',
        name: 'waterstate',
        meta: {
          title: '水表状态',
          auth: true
        },
        component: _import('SheBeiGuanLi/waterstate')
      },
      {
        path: 'waterswitch',
        name: 'waterswitch',
        meta: {
          title: '水表开关',
          auth: true
        },
        component: _import('SheBeiGuanLi/waterswitch')
      },
      {
        path: 'zhongjianbiao',
        name: 'zhongjianbiao',
        meta: {
          title: '房间绑定',
          auth: true
        },
        component: _import('SheBeiGuanLi/zhongjianbiao')
      },
      // 特色功能
      {
        path: 'chongzhijiaozhun',
        name: 'chongzhijiaozhun',
        meta: {
          title: '充值校准',
          auth: true
        },
        component: _import('TeSeGongNeng/chongzhijiaozhun')
      },
      {
        path: 'TimedOnOffControl',
        name: 'TimedOnOffControl',
        meta: {
          title: '定时控制设置',
          auth: true
        },
        component: _import('TeSeGongNeng/TimedOnOffControl')
      },
      {
        path: 'jiaozhunshijian',
        name: 'jiaozhunshijian',
        meta: {
          title: '校准时间',
          auth: true
        },
        component: _import('TeSeGongNeng/jiaozhunshijian')
      },
      {
        path: 'basicUserParameters',
        name: 'basicUserParameters',
        meta: {
          title: '用户参数设置',
          auth: true
        },
        component: _import('TeSeGongNeng/basicUserParameters')
      },
      {
        path: 'yuzhidianliang',
        name: 'yuzhidianliang',
        meta: {
          title: '预置电量',
          auth: true
        },
        component: _import('TeSeGongNeng/yuzhidianliang')
      },
      {
        path: 'nightset',
        name: 'nightset',
        meta: {
          title: '夜间小功率设置',
          auth: true
        },
        component: _import('TeSeGongNeng/nightset')
      },
      {
        path: 'kongzhiset',
        name: 'kongzhiset',
        meta: {
          title: '控制参数设置',
          auth: true
        },
        component: _import('TeSeGongNeng/kongzhiset')
      },
      {
        path: 'fuzaiset',
        name: 'fuzaiset',
        meta: {
          title: '负载参数设置',
          auth: true
        },
        component: _import('TeSeGongNeng/LoadParameter')
      },
      // 档案管理
      {
        path: 'fangjianguanli',
        name: 'fangjianguanli',
        meta: {
          title: '房间管理',
          auth: true
        },
        component: _import('DangAnGuanLi/fangjianguanli')
      },
      {
        path: 'fenquguanli',
        name: 'fenquguanli',
        meta: {
          title: '项目概况',
          auth: true
        },
        component: _import('DangAnGuanLi/fenquguanli')
      },
      {
        path: 'jianzhuguanli',
        name: 'jianzhuguanli',
        meta: {
          title: '建筑管理',
          auth: true
        },
        component: _import('DangAnGuanLi/jianzhuguanli')
      },
      {
        path: 'userbangding',
        name: 'userbangding',
        meta: {
          title: '用户绑定',
          auth: true
        },
        component: _import('DangAnGuanLi/userbangding')
      },
      {
        path: 'userdangan',
        name: 'userdangan',
        meta: {
          title: '用户档案',
          auth: true
        },
        component: _import('DangAnGuanLi/userdangan')
      },
      {
        path: 'dsshijianduan',
        name: 'dsshijianduan',
        meta: {
          title: '定时时间段',
          auth: true
        },
        component: _import('JiChuCanShu/dsshijianduan')
      },
      {
        path: 'dstongduancanshu',
        name: 'dstongduancanshu',
        meta: {
          title: '定时通断参数',
          auth: true
        },
        component: _import('JiChuCanShu/dstongduancanshu')
      },
      {
        path: 'gonglvcanshu',
        name: 'gonglvcanshu',
        meta: {
          title: '功率参数',
          auth: true
        },
        component: _import('JiChuCanShu/gonglvcanshu')
      },
      {
        path: 'kongzhicanshu',
        name: 'kongzhicanshu',
        meta: {
          title: '控制参数',
          auth: true
        },
        component: _import('JiChuCanShu/kongzhicanshu')
      },
      {
        path: 'fuzaicanshu',
        name: 'fuzaicanshu',
        meta: {
          title: '负载参数',
          auth: true
        },
        component: _import('JiChuCanShu/fuzaicanshu')
      },
      {
        path: 'night',
        name: 'night',
        meta: {
          title: '夜间小功率限制',
          auth: true
        },
        component: _import('JiChuCanShu/night')
      },
      {
        path: 'mianfeidianzscs',
        name: 'mianfeidianzscs',
        meta: {
          title: '免费电赠送参数',
          auth: true
        },
        component: _import('JiChuCanShu/mianfeidianzscs')
      },
      {
        path: 'danjiabiao',
        name: 'danjiabiao',
        meta: {
          title: '单价表',
          auth: true
        },
        component: _import('JiChuCanShu/danjiabiao')
      },
      {
        path: 'chaobiao',
        name: 'chaobiao',
        meta: {
          title: '房间用电统计',
          auth: true
        },
        component: _import('TongJiFenXi/chaobiao')
      },
      {
        path: 'MeterReadingRecordDetails',
        name: 'MeterReadingRecordDetails',
        meta: {
          title: '电表抄表记录',
          auth: true
        },
        component: _import('TongJiFenXi/MeterReadingRecordDetails')
      },
      {
        path: 'continuitytable',
        name: 'continuitytable',
        meta: {
          title: '断电记录',
          auth: true
        },
        component: _import('TongJiFenXi/continuitytable')
      },
      {
        path: 'chaobiao_water',
        name: 'chaobiao_water',
        meta: {
          title: '水表抄表记录',
          auth: true
        },
        component: _import('TongJiFenXi/chaobiao_water')
      },
      {
        path: 'chongzhidingdan',
        name: 'chongzhidingdan',
        meta: {
          title: '充值订单统计',
          auth: true
        },
        component: _import('TongJiFenXi/chongzhidingdan')
      },
      {
        path: 'chongzhiwater',
        name: 'chongzhiwater',
        meta: {
          title: '水表充值订单表',
          auth: true
        },
        component: _import('TongJiFenXi/chongzhiwater')
      },
      {
        path: 'chongzhihuizong',
        name: 'chongzhihuizong',
        meta: {
          title: '充值统计汇总',
          auth: true
        },
        component: _import('TongJiFenXi/chongzhihuizong')
      },
      {
        path: 'chongzhijiaozhunjilu',
        name: 'chongzhijiaozhunjilu',
        meta: {
          title: '充值校准记录',
          auth: true
        },
        component: _import('TongJiFenXi/chongzhijiaozhunjilu')
      },
      {
        path: 'duanxinfasong',
        name: 'duanxinfasong',
        meta: {
          title: '短信发送记录',
          auth: true
        },
        component: _import('TongJiFenXi/duanxinfasong')
      },
      {
        path: 'guzhang',
        name: 'guzhang',
        meta: {
          title: '故障记录表',
          auth: true
        },
        component: _import('TongJiFenXi/guzhang')
      },
      {
        path: 'mfdianzengyu',
        name: 'mfdianzengyu',
        meta: {
          title: '免费电赠予记录',
          auth: true
        },
        component: _import('TongJiFenXi/mfdianzengyu')
      },
      {
        path: 'waterfree',
        name: 'waterfree',
        meta: {
          title: '免费水赠予记录',
          auth: true
        },
        component: _import('TongJiFenXi/waterfree')
      },
      {
        path: 'smsmanage',
        name: 'smsmanage',
        meta: {
          title: '短信发送记录',
          auth: true
        },
        component: _import('TongJiFenXi/smsManage')
      },
      {
        path: 'monthly_order',
        name: 'monthly_order',
        meta: {
          title: '复费率月结',
          auth: true
        },
        component: _import('TongJiFenXi/monthly_order')
      },
      {
        path: 'room_billing_statement',
        name: 'room_billing_statement',
        meta: {
          title: '房间结算统计',
          auth: true
        },
        component: _import('TongJiFenXi/room_billing_statement')
      },
      {
        path: 'room_billing_details',
        name: 'room_billing_details',
        meta: {
          title: '房间结算详情',
          auth: true
        },
        component: _import('TongJiFenXi/room_billing_details')
      },
      {
        path: 'tuxingbaobiao',
        name: 'tuxingbaobiao',
        meta: {
          title: '图形报表',
          auth: true
        },
        component: _import('TongJiFenXi/tuxingbaobiao')
      },
      // 系统管理
      {
        path: 'bumen',
        name: 'bumen',
        meta: {
          title: '权限管理',
          auth: true
        },
        component: _import('XiTongGuanLi/bumen')
      },
      {
        path: 'caozuojilu',
        name: 'caozuojilu',
        meta: {
          title: '操作记录',
          auth: true
        },
        component: _import('XiTongGuanLi/caozuojilu')
      },
      {
        path: 'rizhi',
        name: 'rizhi',
        meta: {
          title: '操作记录',
          auth: true
        },
        component: _import('XiTongGuanLi/rizhi')
      },
      {
        path: 'shanchuchaobiaojilu',
        name: 'shanchuchaobiaojilu',
        meta: {
          title: '删除抄表记录',
          auth: true
        },
        component: _import('XiTongGuanLi/shanchuchaobiaojilu')
      },
      {
        path: 'shujukubeifen',
        name: 'shujukubeifen',
        meta: {
          title: '数据库备份',
          auth: true
        },
        component: _import('XiTongGuanLi/shujukubeifen')
      },
      // 系统 前端日志
      {
        path: 'log',
        name: 'log',
        meta: {
          title: '前端日志',
          auth: true
        },
        component: _import('system/log')
      },
      // 刷新页面 必须保留
      {
        path: 'refresh',
        name: 'refresh',
        hidden: true,
        component: _import('system/function/refresh')
      },
      // 页面重定向 必须保留
      {
        path: 'redirect/:route*',
        name: 'redirect',
        hidden: true,
        component: _import('system/function/redirect')
      }
    ]
  }
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: _import('system/login')
  }
]

/**
 * 错误页面
 */
const errorPage = [
  {
    path: '*',
    name: '404',
    component: _import('system/error/404')
  }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage
]
